










































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalEdit/types";

@Component
export default class BasicInfo5 extends Vue {
  @Prop() tab!: MedicalSpecification;
}
